
export const ALLOWED_CONNECTION = 20;
export const CONFERENCE_KICK_TIMER = 180;
export const CONFERENCE_KICK_TIMER_BREAK = 20;
export const USER_NAME_LEN = 30;
export const CURRENT_ROOM_NAME = window.location.pathname.length > 1 ? decodeURIComponent(window.location.pathname.substring(1)) : "";
export const CURRENT_ROOM_LOCATION = window.location.origin + "/" + CURRENT_ROOM_NAME
export const RECONNECT_HIT_TIMER = 0;

export const HOST_RECEIVED_EVENTS = {
    THIRD_PARTY_RECEIVED: "THIRD_PARTY_RECEIVED",
    SELF_HOST_RECEIVED: "SELF_HOST_RECEIVED"
}

const dev = {
    SocketUrl: 'wss://rtastaging.realtimeaudio.com:8443',
    IpListUrl: 'https://rtastaging.realtimeaudio.com:3000/ip.json',
    ServerUrl: 'https://rtastaging.realtimeaudio.com:3000',
    ToastTime: {
        DelayTime: 500,
        HostRoomCloseTime: 1500,
        HostExistTime: 1000,
        LongTime: 5,
        ReconnectingTime: 12000,
        LongCloseTime: 7000,
        VeryLongTime: 20000
    },
    s3RecordingUrl: "rtauatshare",
    chatTranslate: "https://live.realtimeaudio.com:4455",
    socialUrl: "https://social-rta.staging02.com",
    loggerURL: "https://logs.realtimeaudio.com"
};

const live = {
    SocketUrl: 'wss://live.realtimeaudio.com:8443',
    IpListUrl: 'https://live.realtimeaudio.com:3000/ip.json',
    ServerUrl: 'https://live.realtimeaudio.com:3000',
    ToastTime: {
        DelayTime: 500,
        HostRoomCloseTime: 1500,
        HostExistTime: 1000,
        LongTime: 5,
        ReconnectingTime: 12000,
        LongCloseTime: 7000,
        VeryLongTime: 20000
    },
    s3RecordingUrl: "rtastagingvideos",
    chatTranslate: "https://live.realtimeaudio.com:4455",
    socialUrl: "https://social.realtimeaudio.com",
    loggerURL: "https://logs.realtimeaudio.com"
};

export let Constant = {}

if ([
    "https://web.realtimeaudio.com", // RTA Live
    "https://live.matchmysound.com", // MMS Live
    "https://live.duetpartner.com", // DUET Live
    "https://web.oneclickwebcam.com", // TRMC Live
    "https://recordings.realtimeaudio.com", // Recording Live
    "https://social.realtimeaudio.com", // RTA Social Live
].indexOf(window.location.origin) != -1) {
    Constant = {
        App: live
    }
} else {
    Constant = {
        App: dev
    }
}




